import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdePopoverModule } from '@material-extended/mde';
import { OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ComponentsModule } from '../components.module';
import { MyAccountService } from 'src/app/providers/my-account/my-account.service';
import { MY_MOMENT_FORMATS } from 'src/app/utils/date-time';
@NgModule({
  declarations: [FooterComponent, HeaderComponent, NavMenuComponent, ],
  exports: [FooterComponent, HeaderComponent, NavMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    RouterModule,
    PipesModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    ComponentsModule,
    MdePopoverModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  entryComponents: [FooterComponent, HeaderComponent, NavMenuComponent],
  providers: [
    MyAccountService,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'fr' },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  ]
})
export class LayoutsModule { }
